import React from 'react'
import 'whatwg-fetch'
import { Provider } from 'react-redux'
import { Router, browserHistory } from 'react-router'

import store from './store'
import Routes from './routes'

const Root = () => (
  <Provider store={store}>
    <Router history={browserHistory} onUpdate={() => window.scrollTo(0, 0)}>
      {Routes}
    </Router>
  </Provider>
)

export default Root
